
import {Vue, Component, Prop, Watch} from "vue-property-decorator";
import {Getter} from "vuex-class";

@Component({})
export default class RelayAddManagers extends Vue {

    @Prop({default: null})
    public companyId: number;

    @Prop({default: null})
    public managers: any;

    public searchTimeout: any = null;

    @Getter private canDoInEnvCompany: (right: string) => boolean;

    private contacts: any = [];
    private search: string = null;
    private newManagers: any = [];

    public async mounted() {
        this.getManagers();
        this.newManagers = await JSON.parse(JSON.stringify(this.managers));
    }

  @Watch("search")
  @Watch("companyId")
  public handlerSearch() {
    if (this.search || this.search === "") {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.getManagers();
      }, 500);
    } else if (this.companyId) {
      this.getManagers();
    }
  }

    @Watch("newManagers")
    public handleNewManagers() {
        this.$emit("update:managers", this.newManagers);
    }

    private getManagers() {
        if (!this.canDoInEnvCompany("READ_SUBORDINATES")) {
          return this.$store.commit("alerts/displayError", {
            msg: this.$t("alerts.error.cantFetchUsers"),
          });
        }
        Promise.all([
            this.$store.dispatch("companies/getSubordinates", {
                id: this.companyId,
                query: {
                    page : 1,
                    itemsPerPage : 10,
                    search: this.search,
                    groups: true,
                },
            }),
            this.$store.dispatch("companies/getUserGroups", {
                id: this.companyId,
                query: {
                    page : 1,
                    itemsPerPage : 10,
                    search: this.search,
                    type: "subordinates",
                    includeUsersCount: true,
                },
            }),
        ]).then(([subordinates, subordinatesGroups]) => {
            this.contacts = [
                ...subordinates?.users || [],
                ...subordinatesGroups?.list || [],
            ].map((item: any) => ({ ...item }));
        });
    }

    private disableDuplicates(completeList, duplicates) {
        if (!completeList || !duplicates) {
            return null;
        }
        return completeList.map(
            (item: any) => {
                return duplicates.map((elem: any) => elem?.id)?.includes(item?.id) ? {...item, disabled: true} : item;
            },
        );
    }

    private remove(item) {
        const index = this.newManagers.findIndex((i: any) => i?.id === item.id);
        if (index >= 0) {
            this.newManagers.splice(index, 1);
        }
    }

    private getUserGroupPictureSrc(group: any) {
        return group?.type === "user"
            ? group?.Users?.[0]?.picturePath
            : null;
    }

    private getUserGroupPictureDefaultImg(group: any) {
        return group?.type === "user"
            ? "user"
            : "user-group";
    }
}
